import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { USUARIOviewModel } from "../../ViewModels/USUARIOviewModel";

const initialState={
  usuarioActual: new USUARIOviewModel(), //nos almacena el usuario logeado
}

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUsuarioActual: (state, action: PayloadAction<USUARIOviewModel>) =>{
      state.usuarioActual = action.payload
    }
}
});

export const {
  setUsuarioActual
} =authSlice.actions

export default authSlice.reducer